module.exports = __webpack_public_path__ + "4b28c676f32a920b87eb956d2ee8abb3.jpg";